module.exports = require('./SearchProviderView')
